<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> FRETE FORNECEDOR </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="shipping.id">{{
          `${shipping.company.code} - ${shipping.company.name}`
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :visible="!!alert_message"
        dark
        :type="type_alert"
        :message="alert_message"
        :clickClose="() => (alert_message = '')"
      />
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        class="compact-form"
      >
        <v-container fluid>
          <v-row>
            <v-col class="pt-0 pb-2" cols="12" xs="12" md="4">
              <v-radio-group
                v-model="shipping.type"
                class="my-0 pt-0"
                hide-details
                dense
              >
                <template v-slot:label>
                  <div>
                    Selecione se o Frete será por Quantidade ou Valor do Pedido
                  </div>
                </template>
                <v-radio
                  key="value"
                  :label="`Valor do Pedido`"
                  value="value"
                ></v-radio>
                <v-radio
                  key="pair"
                  :label="`Quantidade`"
                  value="pair"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col
              class="py-2"
              cols="12"
              xs="12"
              md="2"
              v-if="shipping.type == 'pair'"
            >
              <v-text-field
                outlined
                dense
                label="Pedido Mínimo"
                v-model.number="shipping.minimum_order"
                :prefix="`${shipping.type == 'pair' ? '' : 'R$'}`"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col
              class="py-2"
              cols="12"
              xs="12"
              md="2"
              v-if="shipping.type != 'pair'"
            >
              <v-text-field-money
                v-model="shipping.minimum_order"
                label="Pedido Mínimo"
                :rules="[rules.required]"
                v-bind:properties="{
                  prefix: shipping.type == 'pair' ? '' : 'R$',
                  readonly: false,
                  dense: true,
                  outlined: true,
                  clearable: false,
                  hideDetails: true,
                  required: true,
                  placeholder: ' ',
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: null,
                }"
              />
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col class="mt-4">
              <label class="text-h6">Exceção</label>
              <v-divider class="mb-1"></v-divider>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col class="pt-4">
              <v-checkbox
                class="mt-0"
                v-model="has_exceptions"
                label="Adicionar Exceção por Região ou Estado?"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="has_exceptions">
            <v-col cols="12" xs="12" sm="6" md="4" lg="3">
              <label class="text-h6">Exceção por Região</label>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="8" lg="9">
              <label class="text-h6">Exceção por Estado</label>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row v-if="has_exceptions">
            <v-col cols="12" xs="12" sm="6" md="4" lg="3">
              <v-card class="mx-auto px-5 py-2" outlined>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Região</th>
                        <th class="text-center" width="170px">Pedido Mínimo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in regions" :key="item.name">
                        <td>{{ item.description }}</td>
                        <td v-if="shipping.type != 'pair'">
                          <v-text-field-money
                            v-model="item.minimum_order"
                            label=""
                            class="input-table"
                            v-bind:properties="{
                              prefix: shipping.type == 'pair' ? '' : 'R$',
                              readonly: false,
                              dense: true,
                              outlined: true,
                              clearable: false,
                              hideDetails: true,
                              placeholder: ' ',
                            }"
                            v-bind:options="{
                              locale: 'pt-BR',
                              length: 11,
                              precision: 2,
                              empty: null,
                            }"
                          />
                        </td>
                        <td v-if="shipping.type == 'pair'">
                          <v-text-field
                            outlined
                            dense
                            label=""
                            hide-details
                            v-model.number="item.minimum_order"
                            :prefix="`${shipping.type == 'pair' ? '' : 'R$'}`"
                            class="input-table"
                          ></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3" lg="3">
              <v-card
                class="mx-auto px-5 py-2"
                outlined
                max-height="274px"
                min-height="274px"
              >
                <v-col cols="12">
                  <v-select
                    :items="filterUF(ufs)"
                    v-model="uf_selected"
                    label="UF"
                    dense
                    clearable
                    outlined
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="blue darken-4"
                    dark
                    class="mt-2"
                    outlined
                    @click="addState()"
                  >
                    Adicionar <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="5" lg="5">
              <v-card
                class="mx-auto px-5 py-2"
                outlined
                min-height="274px"
                max-height="274px"
              >
                <v-col cols="12">
                  <v-simple-table dense height="225px" fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Estado</th>
                          <th class="text-center" width="170px">
                            Pedido Mínimo
                          </th>
                          <th class="text-center" width="80px">Deletar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in states_exceptions" :key="item.name">
                          <td>{{ item.description }}</td>
                          <td v-if="shipping.type != 'pair'">
                            <v-text-field-money
                              v-model="item.minimum_order"
                              label=""
                              class="input-table"
                              v-bind:properties="{
                                prefix: shipping.type == 'pair' ? '' : 'R$',
                                readonly: false,
                                dense: true,
                                outlined: true,
                                clearable: false,
                                hideDetails: true,
                                placeholder: ' ',
                              }"
                              v-bind:options="{
                                locale: 'pt-BR',
                                length: 11,
                                precision: 2,
                                empty: null,
                              }"
                            />
                          </td>
                          <td v-if="shipping.type == 'pair'">
                            <v-text-field
                              outlined
                              dense
                              label=""
                              hide-details
                              v-model.number="item.minimum_order"
                              :prefix="`${shipping.type == 'pair' ? '' : 'R$'}`"
                              class="input-table"
                            ></v-text-field>
                          </td>
                          <td class="text-center">
                            <v-tooltip top color="error">
                              <!-- eslint-disable-next-line -->
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="red darken-1"
                                  @click="deleteState(item)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Deletar</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="blue darken-3"
                dark
                class="mt-2 float-right"
                @click="validate()"
              >
                Salvar <v-icon right>mdi-send</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CompanyPromotionAPI from "@/api/requests/CompanyPromotionRequest";
import * as ShippingCompanyAPI from "@/api/requests/ShippingRequest";

import Alert from "@/components/Alert";
import AwesomeMask from "awesome-mask";
import { UF_LIST, REGIONS } from "@/api/constants";

export default {
  components: {
    Alert,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    date_mask: "99/99/9999",
    loading: false,
    shipping: {},
    has_exceptions: false,
    regions: [],
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    alert_message: "",
    type_alert: "",
    ufs: [],
    uf_selected: "",
    states_exceptions: [],
  }),
  watch: {
    radio_payment_condition(older_value, new_value) {
      if (new_value === "one") {
        this.promotion.payment_condition_id = "";
      }
    },
    "shipping.type": function (val) {
      if (val === "pair") {
        this.shipping.minimum_order = parseInt(this.shipping.minimum_order);
        this.regions = this.regions.map((item) => ({
          ...item,
          minimum_order: !Number.isNaN(parseInt(item.minimum_order))
            ? parseInt(item.minimum_order)
            : "",
        }));
        this.states_exceptions = this.states_exceptions.map((item) => ({
          ...item,
          minimum_order: !Number.isNaN(parseInt(item.minimum_order))
            ? parseInt(item.minimum_order)
            : "",
        }));
      }
    },
  },
  computed: {},
  created() {
    this.ufs = UF_LIST;
    this.initialize();
  },
  methods: {
    async initialize() {
      this.regions = REGIONS;
      this.regions = this.regions.map((item) => ({
        ...item,
        minimum_order: "",
      }));
      if (this.$route.params.id) {
        this.getShipping(this.$route.params.id);
      }
    },
    goToBackList() {
      this.$router.push({ name: "ShippingSettings" });
    },
    validate() {
      this.shipping.regions = this.regions.filter(
        (item) =>
          item.minimum_order !== "" &&
          item.minimum_order !== null &&
          parseInt(item.minimum_order) !== 0
      );
      this.shipping.states = this.states_exceptions.filter(
        (item) => item.minimum_order !== ""
      );
      if (!this.has_exceptions) {
        this.shipping.states = [];
        this.shipping.regions = [];
      }
      console.log(this.shipping);
      let data = { ...this.shipping };
      data.company = {};
      this.post(data);
    },
    async getShipping(id) {
      this.loading = true;
      try {
        let response = await ShippingCompanyAPI.getById(id);
        if (Object.keys(response).length === 0) {
          let company = await CompanyAPI.getById(id);
          this.has_exceptions = false;
          this.shipping = {
            company_id: id,
            company: company,
            type: "value",
            minimum_order: "0.00",
            states: [],
            regions: [],
            status: false,
          };
        } else {
          this.has_exceptions =
            response.states.length > 0 || response.regions.length > 0;
          this.states_exceptions = response.states;

          this.regions = this.regions.map((item) => {
            let res = response.regions.find((reg) => reg.name === item.name);
            let minimum_order = "";
            if (typeof res !== "undefined") {
              minimum_order = res.minimum_order;
            }
            return { ...item, minimum_order: minimum_order };
          });

          console.log(
            response.regions.find((reg) => reg.name === "centro-oeste")
          );

          console.log(this.regions);
          console.log(response.states);
          this.shipping = response;
        }
        console.log(this.shipping);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async post(data) {
      console.log(data);
      this.loading = true;
      try {
        let res = await ShippingCompanyAPI.post(data);
        console.log(res);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        this.alert_message =
          "Erro ao salvar a promoção, tente novamente mais tarde";
        this.type_alert = "error";
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      console.log({ id });
      console.log(data);
      this.loading = true;
      try {
        await CompanyPromotionAPI.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        this.alert_message =
          "Erro ao atualizar a promoção, tente novamente mais tarde";
        this.type_alert = "error";
      } finally {
        this.loading = false;
      }
    },
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
    addState() {
      if (this.uf_selected == "") {
        return;
      }
      let uf = this.ufs.find((item) => item.value == this.uf_selected);
      console.log(uf);
      this.states_exceptions.push({
        name: this.uf_selected,
        description: uf.text,
        minimum_order: "",
      });
      this.uf_selected = "";
      this.states_exceptions = this.states_exceptions.sort((a, b) =>
        a.name > b.name ? 1 : -1
      );
    },
    deleteState(item) {
      let index = this.states_exceptions.findIndex(
        (state) => state.name === item.name
      );
      this.states_exceptions.splice(index, 1);
    },
    filterUF(ufs) {
      return ufs.filter(
        (uf) =>
          this.states_exceptions.find((item) => item.name === uf.value) ===
          undefined
      );
    },
  },
};
</script>
<style scoped>
.v-stepper__wrapper {
  overflow: auto !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 13px !important;
}
.compact-form .fs-12 {
  transform: scale(0.8);
  transform-origin: left;
}
.input-table {
  margin-top: 2px;
  margin-bottom: 2px;
  transform: scale(0.8);
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
